import { create } from "zustand";

interface AriaAnnouncerState {
  message: string;
  priority: "polite" | "assertive";
  actions: {
    announce: (message: string, priority?: "polite" | "assertive") => void;
    clear: () => void;
  };
}

/**
 * Store for managing ARIA live region announcements
 * Used to announce dynamic updates to screen reader users
 */
export const useAriaAnnouncerStore = create<AriaAnnouncerState>((set) => ({
  message: "",
  priority: "polite",
  actions: {
    /**
     * Announce a message to screen readers
     * @param message - The message to announce
     * @param priority - "polite" (default, waits for user to pause) or "assertive" (interrupts immediately)
     */
    announce: (message: string, priority: "polite" | "assertive" = "polite") => {
      // Clear first to ensure the message is re-announced even if it's the same
      set({ message: "", priority });
      // Use setTimeout to ensure screen readers detect the change
      setTimeout(() => {
        set({ message, priority });
        // Auto-clear after announcement (screen readers will have captured it)
        setTimeout(() => {
          set({ message: "" });
        }, 1000);
      }, 50);
    },
    clear: () => set({ message: "" }),
  },
}));
